export default __webpack_public_path__ + "static/media/menu-meteor-5.8cb95c00.png";